import { render, staticRenderFns } from "./CourtesyResponsible.vue?vue&type=template&id=4c3c60ae"
import script from "./CourtesyResponsible.vue?vue&type=script&lang=js"
export * from "./CourtesyResponsible.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports